export const messages = {
  en: {
    listParkingSpace: {
      queryCondition: "Query Conditions",
      parkingLotPlaceholder: "Please select parking lot",
      select: "Select",
      parkingSpaceNumPlaceholder: "Please enter parking space number",
      parkingSpaceStatePlaceholder: "Required, select parking space state",
      forSale: "For Sale",
      forRent: "For Rent",
      free: "Free",
      query: "Query",
      reset: "Reset",
      ownerNamePlaceholder: "Please enter owner name",
      carNumPlaceholder: "Please enter car number",
      parkingSpaceInfo: "Parking Space Information",
      batchAdd: "Batch Add",
      add: "Add",
      parkingLot: "Parking Lot",
      parkingSpace: "Parking Space",
      parkingSpaceState: "Parking Space State",
      parkingSpaceType: "Parking Space Type",
      area: "Area",
      createTime: "Create Time",
      operation: "Operation",
      modify: "Modify",
      delete: "Delete",
      all: "All",
      parkingAreaTreeTitle: "Parking Lot / Section",
      addParkingArea: "Add Parking Lot",
      editParkingArea: "Edit Parking Lot",
      deleteParkingArea: "Delete Parking Lot",
      addSection: "Add Section",
      editSection: "Edit Section",
      deleteSection: "Delete Section",
      section: "Section",
      owner: "Owner",
      carNum: "Car Number",
      rentTime: "Rent Time",
      rent: "Rent",
      sell: "Sell",
      release: "Release",
      updateCar: "Update Car",
      releaseConfirm: "Confirm to release this parking space?",
      releaseSuccess: "Release successfully",
      releaseError: "Failed to release parking space",
      parkingAreaNotFound: "Parking lot not found"
    },
    rentParkingSpace: {
      title: "Rent Parking Space",
      parkingSpace: "Parking Space",
      parkingArea: "Parking Lot",
      carNum: "License Plate Number",
      carNumPlaceholder: "Required, select existing car",
      selectCar: "Select Car",
      carNumQueryPlaceholder: "Enter car number to query",
      carNumRequired: "Car is required",
      carNumSelectPlaceholder: "Optional, select car without parking space under this owner",
      owner: "Owner",
      ownerRequired: "Owner is required",
      ownerPlaceholder: "Required, select owner",
      selectOwner: "Select Owner",
      startTime: "Start Time",
      startTimePlaceholder: "Required, select start time",
      startTimeRequired: "Start time is required",
      endTime: "End Time",
      endTimePlaceholder: "Required, select end time",
      endTimeRequired: "End time is required",
      timeError: "End time must be later than start time",
      errorMessage: "Operation failed"
    },
    addParkingSpace: {
      title: "Add",
      parkingSpaceNum: "Parking Space Number",
      parkingSpaceNumPlaceholder: "Required, enter parking space number",
      parkingLot: "Parking Lot",
      parkingLotPlaceholder: "Required, select parking lot",
      section: "Section",
      sectionPlaceholder: "Optional, select section",
      parkingSpaceType: "Parking Space Type",
      parkingSpaceTypePlaceholder: "Required, select parking space type",
      area: "Area",
      areaPlaceholder: "Required, enter area, e.g. 30.09",
      remark: "Remark",
      remarkPlaceholder: "Optional, enter remark",
      save: "Save",
      cancel: "Cancel"
    },
    editParkingSpace: {
      title: "Edit Parking Space",
      parkingSpaceNum: "Parking Space Number",
      parkingSpaceNumPlaceholder: "Required, enter parking space number",
      parkingLot: "Parking Lot",
      parkingLotPlaceholder: "Required, select parking lot",
      section: "Section",
      sectionPlaceholder: "Optional, select section",
      parkingSpaceType: "Parking Space Type",
      area: "Area",
      areaPlaceholder: "Required, enter area, e.g. 30.09",
      remark: "Remark",
      remarkPlaceholder: "Optional, enter remark",
      save: "Save",
      cancel: "Cancel"
    },
    deleteParkingSpace: {
      title: "Confirm Operation",
      confirmDelete: "Confirm to delete?",
      cancel: "Cancel",
      confirm: "Confirm Delete"
    },
    chooseParkingArea: {
      title: "Select Parking Lot",
      parkingLotNumPlaceholder: "Enter parking lot number",
      query: "Query",
      reset: "Reset",
      parkingLotId: "Parking Lot ID",
      parkingLotNum: "Parking Lot Number",
      parkingLotType: "Parking Lot Type",
      operation: "Operation",
      select: "Select"
    },
    batchAddParkingSpace: {
      title: "Add",
      prefixNum: "Number Prefix",
      prefixNumPlaceholder: "Optional, prefix letters when not pure numbers, e.g. A for A12",
      startNum: "Start Number",
      startNumPlaceholder: "Required, enter starting number",
      endNum: "End Number",
      endNumPlaceholder: "Required, enter ending number",
      parkingLot: "Parking Lot",
      parkingLotPlaceholder: "Required, select parking lot",
      section: "Section",
      sectionPlaceholder: "Optional, select section",
      parkingSpaceType: "Parking Space Type",
      parkingSpaceTypePlaceholder: "Required, select parking space type",
      save: "Save",
      cancel: "Cancel"
    },
    parkingAreaTree: {
      noData: "No parking lot data"
    },
    sectionManage: {
      addTitle: "Add Section",
      editTitle: "Edit Section",
      deleteTitle: "Confirm Operation",
      deleteConfirm: "Confirm to delete this section?",
      parkingArea: "Parking Lot",
      sectionNum: "Section Number",
      sectionNumPlaceholder: "Required, enter section number",
      sectionNumRequired: "Section number is required",
      sectionName: "Section Name",
      sectionNamePlaceholder: "Optional, enter section name",
      remark: "Remark",
      remarkPlaceholder: "Optional, enter remark",
      cancel: "Cancel",
      save: "Save",
      confirm: "Confirm Delete",
      errorMessage: "Operation failed",
      deleteFailed: "Failed to delete section"
    },
    sellParkingSpace: {
      title: "Sell Parking Space",
      sellOrHire: "Operation Type",
      sellOrHireRequired: "Please select operation type",
      hire: "Rent",
      sell: "Sell",
      parkingSpace: "Parking Space",
      parkingArea: "Parking Lot",
      owner: "Owner",
      ownerPlaceholder: "Required, select owner",
      ownerRequired: "Owner is required",
      selectOwner: "Select Owner",
      carNum: "License Plate Number",
      carNumPlaceholder: "Required, select existing car",
      selectCar: "Select Car",
      carNumQueryPlaceholder: "Enter car number to query",
      carNumRequired: "Car is required",
      carNumSelectPlaceholder: "Optional, select car without parking space under this owner",
      carType: "Car Type",
      carTypePlaceholder: "Please select car type",
      carType9901: "Family Car",
      carType9902: "Bus",
      carType9903: "Truck",
      startTime: "Start Time",
      startTimePlaceholder: "Required, select start time",
      startTimeRequired: "Start time is required",
      endTime: "End Time",
      endTimePlaceholder: "Required, select end time",
      endTimeRequired: "End time is required",
      timeRequired: "Start time and end time are required",
      timeError: "End time must be later than start time",
      submit: "Submit",
      cancel: "Cancel",
      errorMessage: "Operation failed"
    },
    updateParkingSpaceCar: {
      title: "Update Parking Space Car",
      parkingSpace: "Parking Space",
      currentOwner: "Current Owner",
      currentCarNum: "Current Car Number",
      currentRentTime: "Current Rent Time",
      newCarNum: "License Plate Number",
      carNum: "Car Number",
      carNumPlaceholder: "Required, select existing car",
      selectCar: "Select Car",
      carNumQueryPlaceholder: "Enter car number to query",
      carNumRequired: "Car is required",
      carNumSelectPlaceholder: "Optional, select car without parking space under this owner",
      owner: "Owner",
      ownerRequired: "Owner is required",
      ownerPlaceholder: "Required, select owner",
      selectOwner: "Select Owner",
      startTime: "Start Time",
      startTimePlaceholder: "Required, select start time",
      startTimeRequired: "Start time is required",
      endTime: "End Time",
      endTimePlaceholder: "Required, select end time",
      endTimeRequired: "End time is required",
      timeError: "End time must be later than start time",
      errorMessage: "Operation failed"
    }
  },
  zh: {
    listParkingSpace: {
      queryCondition: "查询条件",
      parkingLotPlaceholder: "请选择停车场",
      select: "选择",
      parkingSpaceNumPlaceholder: "请填写车位编号",
      parkingSpaceStatePlaceholder: "必填，请选择车位状态",
      forSale: "出售",
      forRent: "出租",
      free: "空闲",
      query: "查询",
      reset: "重置",
      ownerNamePlaceholder: "请填写业主名称",
      carNumPlaceholder: "请填写车牌号",
      parkingSpaceInfo: "停车位信息",
      batchAdd: "批量添加",
      add: "添加",
      parkingLot: "停车场",
      parkingSpace: "车位",
      parkingSpaceState: "车位状态",
      parkingSpaceType: "车位类型",
      area: "面积",
      createTime: "创建时间",
      operation: "操作",
      modify: "修改",
      delete: "删除",
      all: "全部",
      parkingAreaTreeTitle: "停车场 / 区域",
      addParkingArea: "添加停车场",
      editParkingArea: "修改停车场",
      deleteParkingArea: "删除停车场",
      addSection: "添加区域",
      editSection: "修改区域",
      deleteSection: "删除区域",
      section: "区域",
      owner: "业主",
      carNum: "车牌号",
      rentTime: "出租起止时间",
      rent: "出租",
      sell: "出售",
      release: "释放",
      updateCar: "修改车辆",
      releaseConfirm: "确认释放该车位？",
      releaseSuccess: "释放成功",
      releaseError: "释放车位失败",
      parkingAreaNotFound: "未查询到停车场信息"
    },
    rentParkingSpace: {
      title: "出租车位",
      parkingSpace: "车位",
      parkingArea: "停车场",
      carNum: "车牌号",
      carNumPlaceholder: "必填，请选择已有车辆",
      selectCar: "选择车辆",
      carNumQueryPlaceholder: "请输入车牌号查询",
      carNumRequired: "车辆不能为空",
      carNumSelectPlaceholder: "选填，请选择该业主名下无车位车辆",
      owner: "业主",
      ownerRequired: "业主不能为空",
      ownerPlaceholder: "必填，请选择业主",
      selectOwner: "选择业主",
      startTime: "开始时间",
      startTimePlaceholder: "必填，请选择开始时间",
      startTimeRequired: "开始时间不能为空",
      endTime: "结束时间",
      endTimePlaceholder: "必填，请选择结束时间",
      endTimeRequired: "结束时间不能为空",
      timeError: "结束时间必须晚于开始时间",
      errorMessage: "操作失败"
    },
    addParkingSpace: {
      title: "添加",
      parkingSpaceNum: "车位编码",
      parkingSpaceNumPlaceholder: "必填，请填写车位编码",
      parkingLot: "停车场",
      parkingLotPlaceholder: "必填，请选择停车场",
      section: "停车区域",
      sectionPlaceholder: "选填，请选择停车区域",
      parkingSpaceType: "车位类型",
      parkingSpaceTypePlaceholder: "必填，请选择车位类型",
      area: "面积",
      areaPlaceholder: "必填，请填写面积，如30.09",
      remark: "备注",
      remarkPlaceholder: "可填，请填写备注",
      save: "保存",
      cancel: "取消"
    },
    editParkingSpace: {
      title: "修改车位",
      parkingSpaceNum: "车位编码",
      parkingSpaceNumPlaceholder: "必填，请填写车位编码",
      parkingLot: "停车场",
      parkingLotPlaceholder: "必填，请选择停车场",
      section: "停车区域",
      sectionPlaceholder: "选填，请选择停车区域",
      parkingSpaceType: "车位类型",
      area: "面积",
      areaPlaceholder: "必填，请填写面积，如30.09",
      remark: "备注",
      remarkPlaceholder: "可填，请填写备注",
      save: "保存",
      cancel: "取消"
    },
    deleteParkingSpace: {
      title: "请确认您的操作",
      confirmDelete: "确认是否删除!",
      cancel: "点错了",
      confirm: "确认删除"
    },
    chooseParkingArea: {
      title: "选择停车场",
      parkingLotNumPlaceholder: "输入停车场编号",
      query: "查询",
      reset: "重置",
      parkingLotId: "停车场ID",
      parkingLotNum: "停车场编号",
      parkingLotType: "停车场类型",
      operation: "操作",
      select: "选择"
    },
    batchAddParkingSpace: {
      title: "添加",
      prefixNum: "编号前缀",
      prefixNumPlaceholder: "选填，不是纯数字时前面字母 如A12 时填写A",
      startNum: "开始编号",
      startNumPlaceholder: "必填，请填写编码中数字部分开始编号",
      endNum: "结束编号",
      endNumPlaceholder: "必填，请填写编码中数字部分结束编号",
      parkingLot: "停车场",
      parkingLotPlaceholder: "必填，请选择停车场",
      section: "停车区域",
      sectionPlaceholder: "选填，请选择停车区域",
      parkingSpaceType: "车位类型",
      parkingSpaceTypePlaceholder: "必填，请选择车位类型",
      save: "保存",
      cancel: "取消"
    },
    parkingAreaTree: {
      noData: "暂无停车场数据"
    },
    sectionManage: {
      addTitle: "添加区域",
      editTitle: "修改区域",
      deleteTitle: "确认操作",
      deleteConfirm: "是否确定删除该区域？",
      parkingArea: "停车场",
      sectionNum: "区域编号",
      sectionNumPlaceholder: "必填，请填写区域编号",
      sectionNumRequired: "区域编号不能为空",
      sectionName: "区域名称",
      sectionNamePlaceholder: "选填，请填写区域名称",
      remark: "备注",
      remarkPlaceholder: "选填，请填写备注",
      cancel: "取消",
      save: "保存",
      confirm: "确认删除",
      errorMessage: "操作失败",
      deleteFailed: "删除区域失败"
    },
    sellParkingSpace: {
      title: "出售车位",
      sellOrHire: "操作类型",
      sellOrHireRequired: "请选择操作类型",
      hire: "出租",
      sell: "出售",
      parkingSpace: "车位",
      parkingArea: "停车场",
      owner: "业主",
      ownerPlaceholder: "必填，请选择业主",
      ownerRequired: "业主不能为空",
      selectOwner: "选择业主",
      carNum: "车牌号",
      carNumPlaceholder: "必填，请选择已有车辆",
      selectCar: "选择车辆",
      carNumQueryPlaceholder: "请输入车牌号查询",
      carNumRequired: "车辆不能为空",
      carNumSelectPlaceholder: "选填，请选择该业主名下无车位车辆",
      carType: "车辆类型",
      carTypePlaceholder: "请选择车辆类型",
      carType9901: "家用小汽车",
      carType9902: "客车",
      carType9903: "货车",
      startTime: "开始时间",
      startTimePlaceholder: "必填，请选择开始时间",
      startTimeRequired: "开始时间不能为空",
      endTime: "结束时间",
      endTimePlaceholder: "必填，请选择结束时间",
      endTimeRequired: "结束时间不能为空",
      timeRequired: "开始时间和结束时间必填",
      timeError: "结束时间必须晚于开始时间",
      submit: "提交",
      cancel: "取消",
      errorMessage: "操作失败"
    },
    updateParkingSpaceCar: {
      title: "修改车位车辆",
      parkingSpace: "车位",
      currentOwner: "当前业主",
      currentCarNum: "当前车牌号",
      currentRentTime: "当前租期",
      newCarNum: "车牌号",
      carNum: "车牌号",
      carNumPlaceholder: "必填，请选择已有车辆",
      selectCar: "选择车辆",
      carNumQueryPlaceholder: "请输入车牌号查询",
      carNumRequired: "车辆不能为空",
      carNumSelectPlaceholder: "选填，请选择该业主名下无车位车辆",
      owner: "业主",
      ownerRequired: "业主不能为空",
      ownerPlaceholder: "必填，请选择业主",
      selectOwner: "选择业主",
      startTime: "开始时间",
      startTimePlaceholder: "必填，请选择开始时间",
      startTimeRequired: "开始时间不能为空",
      endTime: "结束时间",
      endTimePlaceholder: "必填，请选择结束时间",
      endTimeRequired: "结束时间不能为空",
      timeError: "结束时间必须晚于开始时间",
      errorMessage: "操作失败"
    }
  },
  'zh-TW': {
    listParkingSpace: {
      queryCondition: "查詢條件",
      parkingLotPlaceholder: "請選擇停車場",
      select: "選擇",
      parkingSpaceNumPlaceholder: "請填寫車位編號",
      parkingSpaceStatePlaceholder: "必填，請選擇車位狀態",
      forSale: "出售",
      forRent: "出租",
      free: "閒置",
      query: "查詢",
      reset: "重置",
      ownerNamePlaceholder: "請填寫業主名稱",
      carNumPlaceholder: "請填寫車牌號",
      parkingSpaceInfo: "停車位信息",
      batchAdd: "批量添加",
      add: "添加",
      parkingLot: "停車場",
      parkingSpace: "車位",
      parkingSpaceState: "車位狀態",
      parkingSpaceType: "車位類型",
      area: "面積",
      createTime: "創建時間",
      operation: "操作",
      modify: "修改",
      delete: "刪除",
      all: "全部",
      parkingAreaTreeTitle: "停車場 / 區域",
      addParkingArea: "添加停車場",
      editParkingArea: "修改停車場",
      deleteParkingArea: "刪除停車場",
      addSection: "添加區域",
      editSection: "修改區域",
      deleteSection: "刪除區域",
      section: "區域",
      owner: "業主",
      carNum: "車牌號",
      rentTime: "出租起止時間",
      rent: "出租",
      sell: "出售",
      release: "釋放",
      updateCar: "修改車輛",
      releaseConfirm: "確認釋放該車位？",
      releaseSuccess: "釋放成功",
      releaseError: "釋放車位失敗",
      parkingAreaNotFound: "未查詢到停車場信息"
    },
    rentParkingSpace: {
      title: "出租車位",
      parkingSpace: "車位",
      parkingArea: "停車場",
      carNum: "車牌號",
      carNumPlaceholder: "必填，請選擇已有車輛",
      selectCar: "選擇車輛",
      carNumQueryPlaceholder: "請輸入車牌號查詢",
      carNumRequired: "車輛不能為空",
      carNumSelectPlaceholder: "選填，請選擇該業主名下無車位車輛",
      owner: "業主",
      ownerRequired: "業主不能為空",
      ownerPlaceholder: "必填，請選擇業主",
      selectOwner: "選擇業主",
      startTime: "開始時間",
      startTimePlaceholder: "必填，請選擇開始時間",
      startTimeRequired: "開始時間不能為空",
      endTime: "結束時間",
      endTimePlaceholder: "必填，請選擇結束時間",
      endTimeRequired: "結束時間不能為空",
      timeError: "結束時間必須晚於開始時間",
      errorMessage: "操作失敗"
    },
    addParkingSpace: {
      title: "添加",
      parkingSpaceNum: "車位編碼",
      parkingSpaceNumPlaceholder: "必填，請填寫車位編碼",
      parkingLot: "停車場",
      parkingLotPlaceholder: "必填，請選擇停車場",
      section: "停車區域",
      sectionPlaceholder: "選填，請選擇停車區域",
      parkingSpaceType: "車位類型",
      parkingSpaceTypePlaceholder: "必填，請選擇車位類型",
      area: "面積",
      areaPlaceholder: "必填，請填寫面積，如30.09",
      remark: "備註",
      remarkPlaceholder: "可填，請填寫備註",
      save: "保存",
      cancel: "取消"
    },
    editParkingSpace: {
      title: "修改車位",
      parkingSpaceNum: "車位編碼",
      parkingSpaceNumPlaceholder: "必填，請填寫車位編碼",
      parkingLot: "停車場",
      parkingLotPlaceholder: "必填，請選擇停車場",
      section: "停車區域",
      sectionPlaceholder: "選填，請選擇停車區域",
      parkingSpaceType: "車位類型",
      area: "面積",
      areaPlaceholder: "必填，請填寫面積，如30.09",
      remark: "備註",
      remarkPlaceholder: "可填，請填寫備註",
      save: "保存",
      cancel: "取消"
    },
    deleteParkingSpace: {
      title: "請確認您的操作",
      confirmDelete: "確認是否刪除!",
      cancel: "點錯了",
      confirm: "確認刪除"
    },
    chooseParkingArea: {
      title: "選擇停車場",
      parkingLotNumPlaceholder: "輸入停車場編號",
      query: "查詢",
      reset: "重置",
      parkingLotId: "停車場ID",
      parkingLotNum: "停車場編號",
      parkingLotType: "停車場類型",
      operation: "操作",
      select: "選擇"
    },
    batchAddParkingSpace: {
      title: "添加",
      prefixNum: "編號前綴",
      prefixNumPlaceholder: "選填，不是純數字時前面字母 如A12 時填寫A",
      startNum: "開始編號",
      startNumPlaceholder: "必填，請填寫編碼中數字部分開始編號",
      endNum: "結束編號",
      endNumPlaceholder: "必填，請填寫編碼中數字部分結束編號",
      parkingLot: "停車場",
      parkingLotPlaceholder: "必填，請選擇停車場",
      section: "停車區域",
      sectionPlaceholder: "選填，請選擇停車區域",
      parkingSpaceType: "車位類型",
      parkingSpaceTypePlaceholder: "必填，請選擇車位類型",
      save: "保存",
      cancel: "取消"
    },
    parkingAreaTree: {
      noData: "暫無停車場數據"
    },
    sectionManage: {
      addTitle: "添加區域",
      editTitle: "修改區域",
      deleteTitle: "確認操作",
      deleteConfirm: "是否確定刪除該區域？",
      parkingArea: "停車場",
      sectionNum: "區域編號",
      sectionNumPlaceholder: "必填，請填寫區域編號",
      sectionNumRequired: "區域編號不能為空",
      sectionName: "區域名稱",
      sectionNamePlaceholder: "選填，請填寫區域名稱",
      remark: "備註",
      remarkPlaceholder: "選填，請填寫備註",
      cancel: "取消",
      save: "保存",
      confirm: "確認刪除",
      errorMessage: "操作失敗",
      deleteFailed: "刪除區域失敗"
    },
    sellParkingSpace: {
      title: "出售車位",
      sellOrHire: "操作類型",
      sellOrHireRequired: "請選擇操作類型",
      hire: "出租",
      sell: "出售",
      parkingSpace: "車位",
      parkingArea: "停車場",
      owner: "業主",
      ownerPlaceholder: "必填，請選擇業主",
      ownerRequired: "業主不能為空",
      selectOwner: "選擇業主",
      carNum: "車牌號",
      carNumPlaceholder: "必填，請選擇已有車輛",
      selectCar: "選擇車輛",
      carNumQueryPlaceholder: "請輸入車牌號查詢",
      carNumRequired: "車輛不能為空",
      carNumSelectPlaceholder: "選填，請選擇該業主名下無車位車輛",
      carType: "車輛類型",
      carTypePlaceholder: "請選擇車輛類型",
      carType9901: "家用小汽車",
      carType9902: "客車",
      carType9903: "貨車",
      startTime: "開始時間",
      startTimePlaceholder: "必填，請選擇開始時間",
      startTimeRequired: "開始時間不能為空",
      endTime: "結束時間",
      endTimePlaceholder: "必填，請選擇結束時間",
      endTimeRequired: "結束時間不能為空",
      timeRequired: "開始時間和結束時間必填",
      timeError: "結束時間必須晚於開始時間",
      submit: "提交",
      cancel: "取消",
      errorMessage: "操作失敗"
    },
    updateParkingSpaceCar: {
      title: "修改車位車輛",
      parkingSpace: "車位",
      currentOwner: "當前業主",
      currentCarNum: "當前車牌號",
      currentRentTime: "當前租期",
      newCarNum: "車牌號",
      carNum: "車牌號",
      carNumPlaceholder: "必填，請選擇已有車輛",
      selectCar: "選擇車輛",
      carNumQueryPlaceholder: "請輸入車牌號查詢",
      carNumRequired: "車輛不能為空",
      carNumSelectPlaceholder: "選填，請選擇該業主名下無車位車輛",
      owner: "業主",
      ownerRequired: "業主不能為空",
      ownerPlaceholder: "必填，請選擇業主",
      selectOwner: "選擇業主",
      startTime: "開始時間",
      startTimePlaceholder: "必填，請選擇開始時間",
      startTimeRequired: "開始時間不能為空",
      endTime: "結束時間",
      endTimePlaceholder: "必填，請選擇結束時間",
      endTimeRequired: "結束時間不能為空",
      timeError: "結束時間必須晚於開始時間",
      errorMessage: "操作失敗"
    }
  }
}
